import React from 'react';
import { ApplyButton } from './ApplyButton';
import { ScrollReveal } from './ScrollReveal';
export function Footer() {
  return <footer className="bg-slate-dark text-cream pt-32 pb-12 px-6 relative overflow-hidden border-t border-cream/10" data-id="element-15">
      <div className="max-w-4xl mx-auto text-center mb-24 relative z-10" data-id="element-16">
        <ScrollReveal width="100%" data-id="element-17">
          <h2 className="font-serif text-4xl md:text-6xl mb-8 leading-tight text-cream" data-id="element-18">
            Your peace is not the price of your profit.
            <br data-id="element-19" />
            <span className="italic text-cream/70" data-id="element-20">It's the foundation.</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2} width="100%" data-id="element-21">
          <p className="font-sans text-lg md:text-xl text-cream/50 mb-12 tracking-wide font-light" data-id="element-22">
            The Omnipreneur Incubator — 12 weeks of embodied structural
            alignment for established women entrepreneurs ready to scale with
            coherence.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.4} width="100%" data-id="element-23">
          <ApplyButton inverted data-id="element-24" />
        </ScrollReveal>
      </div>

      <div className="max-w-7xl mx-auto border-t border-cream/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-cream/40 font-sans" data-id="element-25">
        <p data-id="element-26">&copy; 2025 The Omnipreneur Incubator. All rights reserved.</p>
        <div className="flex space-x-8 mt-4 md:mt-0" data-id="element-27">
          <a href="#" className="hover:text-cream transition-colors duration-300" data-id="element-28">
            Instagram
          </a>
          <a href="#" className="hover:text-cream transition-colors duration-300" data-id="element-29">
            LinkedIn
          </a>
          <a href="#" className="hover:text-cream transition-colors duration-300" data-id="element-30">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}